export enum UserTypeId {
  TRAVEL = 1,
  NURSE = 100,
  ALLIED = 200,
}
